<template>
  <v-dialog v-model="dialogStatus" max-width="800" transition="dialog-bottom-transition" scrollable>
    <v-card class="mx-auto">
      <div class="d-flex align-end my-3">
        <v-card class="green py-4 px-4 ml-6 mr-3 mt-6">
          <v-icon color="white"> mdi-bookmark </v-icon>
        </v-card>
        <span class="h4 ml-1 mb-n1">更新版本</span>
      </div>
      <v-card-text>
        <v-form ref="form" class="px-15" :style="{padding:isMobile.isMobile?'0 0px !important':'60px'}">
          <v-select
            v-model="currentVersion.tag"
            @change="handleVersionChange"
            :items="tagAll"
            label="版本"
            required
            multiple
            chips
            item-color="purple"
            item-text="label"
            item-value="value"
            no-data-text="暂无版本可数据"
            map-keys="value"
          ></v-select>
      
          <p style="font-size: 14px; color: #333">请选择更新的章节及任务</p>
        
          <v-treeview
            v-model="includeTaskDict"
            selectable
            selected-color="green"
            item-key="_id"
            :items="courseTree"
            hint="请选择章节以及任务"
          ></v-treeview>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green" dark @click.stop="submit">提交</v-btn>
        <v-btn color="gray" @click.stop="dialogStatus = false">取消</v-btn>
      </v-card-actions>
    </v-card>
    <!-- 加载框 -->
    <v-overlay :value="overlay">
      <v-card class="d-flex flex-column justify-center white px-10">
        <div class="d-flex justify-center py-5">
          <v-progress-circular indeterminate color="success"></v-progress-circular>
        </div>
        <div class="d-flex justify-center pb-5 green--text text-bold">
          {{ uploadProgress }}
        </div>
      </v-card>
    </v-overlay>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
import { updateSimulation, listSimulationByCourse } from '@/api/simulation';
import { queryAllProjectAndTask } from '@/api/course';
import { getossUploadToken } from '@/api/user';
import Oss from 'ali-oss';
export default {
  props: {
    showPublishVersion: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    ...mapGetters(['project', 'taskList', 'course','isMobile']),
    dialogStatus: {
      get() {
        return this.showPublishVersion;
      },
      set(val) {
       if (!val) {
        this.$emit('close');
       }
      },
    },
  },
  watch: {
    showPublishVersion(val) {
      if (val) {
        this.getTreeData();
        this.$nextTick(() => {
          this.$refs.form.reset();
        });
      }
    },
  },
  data() {
    return {
      currentVersion: {},
      uploadDialog: false,
      btnloading: false,
      zyTypeList: [
        {
          type: 'img',
          name: '图片',
          id: 1,
        },
        {
          type: 'video',
          name: '视频',
          id: 2,
        },
      ],
      tagAll: [
        {
          id:1,
          label: 'PC',
          value: 'PC',
        },
        {
          id:2,
          label: 'VR',
          value: 'VR',
        },
        {
          id:3,
          label: 'WebGL',
          value: 'WebGL',
        },
        {
          id:4,
          label: '安卓',
          value: 'Android',
        },
        {
          id:5,
          label: 'ZSpace',
          value: 'ZSpace',
        },
        {
          id:6,
          label: 'KMAX',
          value: 'KMAX',
        },
        {
          id:7,
          label: '单机模式',
          value: 'standalone',
        },
      ],
      tab: '',
      form: {
        cover: [],
        type: 'img',
        preImg: [], //图片
        videoPreImg: '', //视频预览图
        preVideo: [],
        tag:[],
      },
      keywords: '',
      valid: false,
      previewImg: null,
      uploadProgress: '',
      overlay: false,
      currentFile: null,
      courseTree: [],
      selectedItem: 'PC',
      selectedVersion: [],
      includeTaskDict: [],
      simulationList: []
    };
  },
  methods: {
    handleVersionChange(val) {
      this.includeTaskDict = val.includeTaskDict;
    },
    async findVersions() {
      const res = await listSimulationByCourse({ courseId: this.course._id })
      this.simulationList = res.data.filter(item => item.apply_status === 1)
      if (this.simulationList.length === 0) {
        this.$message.error('暂未发布版本');
        this.dialogStatus = false;
        return;
      }
      this.currentVersion = this.simulationList[0]
      this.includeTaskDict = this.currentVersion.includeTaskDict
    },
    // async getTreeData() {
    //   await getCourseTree({ id: this.course.id }).then(res => {
    //     this.courseTree = res.data;
    //   });
    // },
    close() {
      this.$emit('close');
    },
    handleUpload() {
      this.uploadDialog = true;
    },
    handleUploadSuccess(response) {
      this.form.preImg.push(response);
      this.uploadDialog = false;
    },
    handleUploadError(error) {
      console.error('上传失败:', error);
    },
    async save() {
      let _this = this;
      if (this.form.type == 'img') {
        //图片
        this.btnloading = true;

        const uploadPromises = [];
        for (let i = 0; i < this.form.preImg.length; i++) {
          const file = this.form.preImg[i];
          uploadPromises.push(this.uploadImage(file, 'preImg'));
        }
        Promise.all(uploadPromises)
          .then(addresses => {
            addresses.forEach(item => {
              let obj = {
                id: _this.guid(),
                url: item.url,
              };
              _this.form.cover.push(obj);
            });
            _this.btnloading = false;
            _this.close();
          })
          .catch(error => {
            console.error('上传图片出错:', error);
            _this.close();
          });
      } else {
        //视频
        console.log(this.form.videoPreImg);
        if (!this.form.videoPreImg) {
          this.$notify({
            timeout: 1500,
            message: '请上传视频预览图',
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'warning',
          });
          return;
        }

        _this.btnloading = true;
        let videoPreImg = await this.uploadImage(this.form.videoPreImg, 'videoPreImg');

        const uploadPromises = [];
        for (let i = 0; i < this.form.preVideo.length; i++) {
          const file = this.form.preVideo[i];
          uploadPromises.push(this.uploadImage(file, 'preVideo'));
        }
        Promise.all(uploadPromises)
          .then(addresses => {
            addresses.forEach(item => {
              let obj = {
                id: _this.guid(),
                url: item.url,
                playerOptions: {},
                poster: videoPreImg.url,
              };

              obj.playerOptions = {
                // loop: false, // 导致视频一结束就重新开始。
                // preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                // aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                // fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                controlBar: {
                  timeDivider: true,
                  durationDisplay: true,
                  remainingTimeDisplay: false,
                  fullscreenToggle: true, //全屏按钮
                },
                height: '350',
                autoplay: false, //如果true,浏览器准备好时开始回放。
                muted: false, // 默认情况下将会消除任何音频。
                language: 'en', //zh-CN
                playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
                sources: [
                  {
                    type: 'video/mp4',
                    // mp4
                    src: item.url,
                    // webm
                    // src: "https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm"
                  },
                ],
                poster: videoPreImg.url, //你的封面地址
              };

              _this.form.cover.push(obj);
            });
            _this.btnloading = false;
            _this.close();
          })
          .catch(error => {
            console.error('上传图片出错:', error);
            _this.close();
            _this.btnloading = false;
          });
      }
    },
    close() {
      this.uploadDialog = false;
      this.form.preImg = null;
      this.form.preVideo = null;
    },

    // 单个图片上传函数
    uploadImage(param, type) {
      return new Promise((resolve, reject) => {
        getossUploadToken({})
          .then(result => {
            const creditInfo = result.data;
            const aliOss = new Oss(creditInfo);
            aliOss
              .put(`${type}/${new Date().getTime()}/${param.name}`, param, {
                headers: {
                  'Access-Control-Allow-Origin': '*',
                },
              })
              .then(res => {
                resolve(res);
              });
          })
          .catch(err => {
            reject(err);
            console.log(err);
          });
      });
    },

    guid() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },
    beforeUpload(file) {
      const allowedTypes = ['image/jpeg', 'image/png'];
      const isAllowed = allowedTypes.includes(file.type);
      // const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isAllowed) {
        this.$message.error('只能上传JPG/PNG格式的图片!');
      }
      // if (!isLt2M) {
      //   this.$message.error('上传的图片大小不能超过 2MB!');
      // }

      return isAllowed;
    },
    clear() {
      if (this.form.type == 'img') {
        this.form.videoPreImg = null;
        this.form.preVideo = null;
      } else {
        this.form.preImg = null;
      }
    },
    delImg(items) {
      this.form.cover = this.form.cover.filter(item => item.id !== items.id);
    },
    guid() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },
    handleSelected(e, value) {
      if (e) {
        this.selectedVersion.push(value);
        return;
      }
      const index = this.selectedVersion.findIndex(item => item === value);
      if (index !== -1) {
        this.selectedVersion.splice(index, 1);
      }
    },
    getTreeData() {
      queryAllProjectAndTask(this.$route.query.detailId).then(res => {
        res.data.forEach((element, index) => {
          element.name = `章节${element.orderNum}. ${element.name}`;
          element.children = element.children.map(item => {
            item.name = `任务${item.sortNum}. ${item.name}`;
            return item;
          });
        });
        this.courseTree = res.data;
        this.findVersions()
      });
    },
    fileChange(e) {
      console.log({
        e,
        f: this.form,
      });
      return e;
    },
    async submit() {
      if (!this.currentVersion || !this.currentVersion._id) {
        this.$store.dispatch('global/showWarningMsg', '请选择版本');
        return;
      }
      this.overlay = true;
      this.uploadProgress = '资源更新中...'
      const addRes = await updateSimulation({
        _id: this.currentVersion._id,
        includeTaskDict: this.includeTaskDict,
        tag: this.currentVersion.tag,
      });
      this.overlay = false;
      this.uploadProgress = ''
      if (addRes.code == 200) {
        this.dialogStatus = false;
        this.$store.dispatch(
          'global/showSuccessMsg',
          '课程版本内容已更新'
        );
      } else {
        this.$store.dispatch('global/showWarningMsg', '系统错误，请稍后尝试');
      }


    },
  },
};
</script>
<style>
.choose-img__input {
  width: 80px;
  height: 31px;
  position: absolute;
  left: 0;
  opacity: 0;
}
.check-img__input {
  width: 80px;
  height: 31px;
  position: absolute;
  left: 58px;
  opacity: 0;
}

.MobileImgStyle{
  display: flex;
  justify-content:space-between;
  align-items: center;
  flex-wrap: wrap;
}
</style>
